import {THEMES} from "./themes";

/** Réglages du fond Vague (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    theme: {
        type: "choix", libelle: "Couleur", defaut: "auto",
        options: [{valeur: "auto", libelle: "Automatique (change avec le mois)"}]
            .concat(Object.keys(THEMES).map(valeur => ({valeur, libelle: THEMES[valeur].nom}))),
    },
    vitesse: {
        type: "nombre", libelle: "Vitesse", min: 0.5, max: 3, pas: 0.1, defaut: 1, unite: "×",
        aide: "×1 est la vitesse d'origine, lente et apaisante.",
    },
    rubans: {
        type: "nombre", libelle: "Rubans", min: 2, max: 8, pas: 1, defaut: 5,
        aide: "Plus il y en a, plus la vague est dense.",
    },
};
